export default [
    {
        path: 'assinatura-eletronica',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-assinatura-eletronica' */
            '@/views/ambulatorio/assinatura-eletronica/Index'
        ),
        redirect: 'assinatura-eletronica/index',
        children: [
            {
                name: 'ambulatorio-assinatura-eletronica-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-assinatura-eletronica' */
                    '@/views/ambulatorio/assinatura-eletronica/List'
                ),
            },
        ]
    }
]